/*
 * WeekplanCalendar Messages
 *
 * This contains all the text for the WeekplanCalendar component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  applyForShift: {
    id: 'app.components.ApplyForShiftButton.applyForShift',
    defaultMessage: 'Apply',
  },
  applyForPlannedShift: {
    id: 'app.components.ApplyForShiftButton.applyForPlannedShift',
    defaultMessage: 'Apply as Backup',
  },
  applyForShiftSuccess: {
    id: 'app.containers.ApplyForShiftButton.applyForShiftSuccess',
    defaultMessage: 'Successfully applied for shift',
  },
  applyForShiftFailure: {
    id: 'app.containers.ApplyForShiftButton.applyForShiftFailure',
    defaultMessage: 'ApplicationCalendar failed',
  },
});
